import SendEmailDialog from 'components/SendEmailDialog/SendEmailDialog';

export default SendEmailDialog;
